import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AlertDialogState } from "./alertDialog.state";
import { AlertDialogItem } from "./alertDialog.types";

const initialState: AlertDialogState = {
  alertDialog: null,
  isLoading: false,
};

const alertDialogSlice = createSlice({
  name: "alertDialog",
  initialState,
  reducers: {
    show: (state, action: PayloadAction<AlertDialogItem>) => {
      state.alertDialog = action.payload;
      state.isLoading = false;
    },
    hide: (state) => {
      state.alertDialog = null;
      state.isLoading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { show, hide, setLoading } = alertDialogSlice.actions;
export default alertDialogSlice.reducer;